import { Button } from '@components/Button'
import { Form, Formik } from 'formik'
import { InputField } from '@components/forms/InputField'
import { SearchIcon } from '@components/Icons'
import { SelectButton } from '../../../../components/SelectButton'
import { SalesByUserSearchFormProps } from './interface'

export function SalesByUserSearchForm({
  initialValues,
  handleSubmit,
  handleResetSearch,
  handleSelectDateRange,
  dateLabel,
}: SalesByUserSearchFormProps) {
  return (
    <>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ values, resetForm }) => (
          <Form>
            <div className='flex flex-col'>
              <div className='flex justify-between items-end'>
                <div className='flex items-end gap-x-[10px]'>
                  <InputField
                    name='text'
                    className='w-[650px]'
                    placeholder='ค้นหาด้วยชื่อ หรือ ID'
                    autoTrim={false}
                    leftIcon={<SearchIcon className='text-primary' />}
                    inputClassName='rounded-[20px] bg-blue-2 placeholder:text-blue-3 placeholder:h-[40px] '
                  />
                </div>
                <div className='flex font-mitr justify-end gap-x-[20px]'>
                  <Button
                    type='button'
                    className='text-secondary underline whitespace-pre px-0'
                    onClick={() => {
                      resetForm({
                        values: {
                          text: '',
                        },
                      })
                      handleResetSearch()
                    }}
                  >
                    ล้างค่า
                  </Button>
                  <Button type='submit' className='bg-secondary text-white '>
                    <span className='text-[14px]'>ค้นหา</span>
                  </Button>
                </div>
                <div className='flex border-l pl-[25px]'>
                  <SelectButton
                    label='เลือกดู'
                    className='w-[167px]'
                    setValue={handleSelectDateRange}
                    selectedLabel={dateLabel}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
